export const PetsRedirect = () => {
  window.location.reload();
  return null;
};
